/**
 * 九个对外 PPT 路由与运营后台模块一一对应；moduleCode 与路由 path 一致（不含前导 /）。
 */
export const PPT_MODULES = {
  cq_jm: { title: "重庆·军民", designWidth: 2176, designHeight: 960 },
  cq_rt: { title: "重庆·遨博", designWidth: 2176, designHeight: 960 },
  xsq_jm: { title: "西三旗·军民1", designWidth: 1920, designHeight: 1080 },
  xsq_jm2: { title: "西三旗·军民2", designWidth: 1920, designHeight: 1080 },
  sjq_jm: { title: "四季青·军民1", designWidth: 2048, designHeight: 832 },
  sjq_jm2: { title: "四季青·军民2", designWidth: 2048, designHeight: 832 },
  rt_jm: { title: "融通·军民1", designWidth: 1920, designHeight: 1080 },
  rt_jm2: { title: "融通·军民2", designWidth: 1920, designHeight: 1080 },
  ts_rb: { title: "唐山·机器人", designWidth: 3096, designHeight: 1376 }
};

export const PPT_MODULE_CODES = Object.keys(PPT_MODULES);

export function isValidModuleCode(code) {
  return Boolean(code && PPT_MODULES[code]);
}
